import React from 'react'
import styled, { useTheme } from 'styled-components';
import Container from '../styleguide/layout/Container';


// typography -- "../styleguide/typography"
import { H5, P } from '../styleguide/typography';

// common components -- "./"
import Button from "./Button"
import NavigationLink from "./NavigationLink"
import AppStoreLinks from './AppStoreLinks';

// layout components -- "../styleguide/layout"
import { Flex } from "../styleguide/layout";

// image -- "../../assets/logo.png" footer logo
import logoWhite from "../../assets/logoWhite.png";

// social icons
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => {

  const theme = useTheme();

  return (
    <Flex width="100%" bg={theme.colors.primary} position="static">
      <Container>
        <Flex 
          width="100%" 
          justify="space-between" 
          gap="2rem" 
          gapMobile="4rem" 
          align="flex-start" 
          margin="3rem 0" 
          directionMobile="column"
        >
      
          {/* first column */}
          <Flex direction="column">
            <LogoImage src={logoWhite} alt="logo" loading='lazy' />
            <P color={theme.colors.white} margin="2rem 0" weight={theme.fontWeights.normal} maxWidth="360px" lineHeight={theme.lineHeights.normal}>
              Mula Finance leverages the use of the blockchain technology and the integration 
              of existing financial systems to offer an African-wide, cross boarder 
              money transfer and remittance solution.
            </P>

            <Button text="Get Started" to="/"/>
          </Flex>

          {/* second column */}
          <Flex direction="column">
            <H5 color={theme.colors.white} margin="0 0 1.5rem 0">Quick Link</H5>
            <Flex direction="column" gap="1.5rem" wrapMobile="wrap" directionMobile="row" gapMobile="2rem">
              <NavigationLink footer to="/">Home</NavigationLink>
              <NavigationLink footer to="about">About</NavigationLink>
              <NavigationLink footer to="products">Products</NavigationLink>
              <NavigationLink footer to="mula-token">Mula Tokens</NavigationLink>
              <NavigationLink footer to="faqs">FAQS</NavigationLink>
              <NavigationLink footer to="blogs">Blogs</NavigationLink>
            </Flex>
          </Flex>

          {/* third column */}
          <Flex direction="column">
            <H5 color={theme.colors.white} margin="0 0 1.5rem 0">Get App & Wallet</H5>
            <P color={theme.colors.white} weight={theme.fontWeights.normal} maxWidth="310px" lineHeight={theme.lineHeights.normal}>
              Trusted by 70M+ traders, major banks, institutional and 
              renowned investors, and hedge funds.
            </P>

            {/* app store buttons */}
            <AppStoreLinks />

            {/* social media icons */}
            <Flex margin="1.5rem 0 0 0" direction="row" gap="2rem">
              <SocialMediaIcons href="https://facebook.com"><FaFacebookF /></SocialMediaIcons>
              <SocialMediaIcons href="https://instagram.com"><FaInstagram /></SocialMediaIcons>
              <SocialMediaIcons href="https://youtube.com"><FaYoutube /></SocialMediaIcons>
              <SocialMediaIcons href="https://twitter.com"><FaTwitter /></SocialMediaIcons>
              <SocialMediaIcons href="https://linkedin.com"><FaLinkedin /></SocialMediaIcons>
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </Flex>
  )
}

export default Footer

const LogoImage = styled.img`
  height: 3rem;
  width: auto;
`

const SocialMediaIcons = styled.a`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`